module.exports = __webpack_public_path__ + "static/assets/5f85a3e5a04dd3de4271589dac82d45b.svg";